export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'helpdesk',
      url: '/helpdesk',
      children: [
        {
          name: 'KPI Helpdesk',
          url: '/helpdesk/kpi'
        },
        {
          name: 'Report Helpdesk',
          url: '/helpdesk/report',
          children: [
            {
              'name': 'Best Monthly',
              'url': '/helpdesk/report/monthly'
            },
            {
              'name': 'Best Year',
              'url': '/helpdesk/report/year'
            }
          ]
        },
        {
          'name': 'Vendor',
          'url': '/helpdesk/vendor'
        },
        {
          'name': 'Metric',
          'url': '/helpdesk/metric'
        },
        {
          'name': 'Insentif',
          'url': '/helpdesk/insentif'
        }
      ]
    },
    {
      name: 'HR & GA',
      url: '/hr',
      children: [
        {
          name: 'Insentif',
          url: '/hr/insentif'
        },
        {
          name: 'Desentif',
          url: '/hr/desentif'
        },
        {
          name: 'Metric',
          url: '/hr/metric'
        },
        {
          name: 'Presence',
          url: '/hr/presence'
        }
      ]
    },
    // {
    //   name: 'KPI Helpdesk',
    //   url: '/kpi/helpdesk',
    //   icon: 'icon-speedometer'
    // },
    // {
    //   name: 'Report Helpdesk',
    //   url: '/report/helpdesk',
    //   icon: 'icon-speedometer',
    //   children : [
    //     {
    //       name: 'User',
    //       url: '/report/helpdesk/user',
    //       icon: 'icon-speedometer'
    //     },
    //     {
    //       name: 'BestHelpdesk',
    //       url: '/report/helpdesk/besthelpdesk',
    //       icon: 'icon-speedometer'
    //     }
    //   ]
    // },
    {
      name: 'Engineer',
      url: '/engineer',
      children: [
        {
          name: 'Live Position',
          url: '/engineer/position'
        },
        {
          name: 'Insentif',
          url: '/engineer/insentif'
        }
      ]
    },

  ]
}
